import { render } from "./Footer.vue?vue&type=template&id=3188b9d3"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projets\\2023\\PNB\\GECD\\gecd-police-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__